const CALENDAR_COLLAPSE_ACTIONS = {
    CALENDAR_LOAD_DAY_HEADERS: 'calendar-load-day-headers',
    CALENDAR_TOGGLE_DAY_HEADER_TOGGLE: 'calendar-toggle-day-header-toggle'
};

export default CALENDAR_COLLAPSE_ACTIONS;



// WEBPACK FOOTER //
// ./src/state/reducer/calendarCollapse/actions.js